__turbopack_context__.v({
  "Buttons": "CarouselSection-module-scss-module__O4bbCa__Buttons",
  "Carousel": "CarouselSection-module-scss-module__O4bbCa__Carousel",
  "CarouselButtonNext": "CarouselSection-module-scss-module__O4bbCa__CarouselButtonNext",
  "CarouselButtonPrevious": "CarouselSection-module-scss-module__O4bbCa__CarouselButtonPrevious",
  "Description": "CarouselSection-module-scss-module__O4bbCa__Description",
  "HasBackground": "CarouselSection-module-scss-module__O4bbCa__HasBackground",
  "Inner": "CarouselSection-module-scss-module__O4bbCa__Inner",
  "IsDisabled": "CarouselSection-module-scss-module__O4bbCa__IsDisabled",
  "Slide": "CarouselSection-module-scss-module__O4bbCa__Slide",
  "Swiper": "CarouselSection-module-scss-module__O4bbCa__Swiper",
});
